import React, { useState, useEffect } from "react";
import { Button, Typography, Box, CircularProgress, Alert } from "@mui/material";
import { initiateCloverOAuth, checkCloverOAuthStatus } from "../api/posApi";
import { useSearchParams } from "react-router-dom";

const CloverOAuthSettings: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [authorized, setAuthorized] = useState(false);
  const [merchantId, setMerchantId] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const checkStatus = async (merchantId: string) => {
      try {
        const status = await checkCloverOAuthStatus(merchantId);
        setAuthorized(status.authorized);
        if (status.authorized) {
          setMerchantId(merchantId);
          localStorage.setItem("cloverMerchantId", merchantId); // Store for future checks
        }
      } catch (err) {
        console.error("Clover status check failed:", err);
      }
    };
  
    const cloverStatus = searchParams.get("clover");
    const urlMerchantId = searchParams.get("merchant_id");
  
    if (cloverStatus === "connected" && urlMerchantId) {
      // Save merchant ID from URL and check status
      localStorage.setItem("cloverMerchantId", urlMerchantId);
      checkStatus(urlMerchantId);
      // Clear query params after processing
      setSearchParams({});
    } else {
      // Check existing stored merchant ID
      const storedMerchantId = localStorage.getItem("cloverMerchantId");
      if (storedMerchantId) checkStatus(storedMerchantId);
    }
  }, [searchParams, setSearchParams]);

  const handleConnect = async () => {
    console.log('Initiating Clover OAuth...'); 
    setLoading(true);
    try {
      const { url } = await initiateCloverOAuth();
      window.location.href = url;
    } catch (err) {
      console.error("Error initiating Clover OAuth:", err);
      alert("Failed to start OAuth flow");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Clover Integration
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        Connect your Clover Merchant Account to process card payments via Clover Flex terminal.
      </Typography>

      {authorized ? (
        <Alert severity="success" sx={{ mb: 2 }}>
          ✅ Clover Connected! Merchant ID: {merchantId}
        </Alert>
      ) : (
        <Button variant="contained" color="primary" onClick={handleConnect} disabled={loading}>
          {loading ? <CircularProgress size={20} /> : "Connect to Clover"}
        </Button>
      )}
    </Box>
  );
};

export default CloverOAuthSettings;
